<template>
  <div id="app">
    <!-- Header stylisé avec le texte All On Black -->
    <header class="app-header">
      <div class="logo-text">
        <span class="dot">•</span>
        <span class="text">ALL</span>
        <span class="line"></span>
        <span class="text">ON</span>
        <span class="line"></span>
        <span class="text">BLACK</span>
        <span class="dot">•</span>
      </div>
    </header>

    <!-- Router View qui affiche les pages -->
    <main>
      <router-view />
    </main>

    <!-- Footer avec les droits réservés -->
    <footer class="app-footer">
      <p>© 2024 All On Black. All rights reserved.</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style scoped>
/* Styliser le header et le texte du logo */
.app-header {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #000 !important; /* Fond noir pour le header */
  padding-top: 5em;
  padding-bottom: 0em;
  max-width: 100vw;
  overflow: hidden; /* Empêche le dépassement */
}

.logo-text {
  display: flex;
  align-items: center;
  font-size: clamp(2em, 6vw, 3.5em); /* Ajuste la taille du texte selon la taille de l'écran */
  color: #fff; /* Texte en blanc */
  font-family: 'Bebas Neue', sans-serif; /* Appliquer la police Bebas Neue */
  text-transform: uppercase;
  letter-spacing: 0.1em;
  flex-wrap: wrap; /* Permet le retour à la ligne si nécessaire */
  justify-content: center; /* Centre les éléments */
}

.dot {
  margin: 0 0.5em;
}

.line {
  display: inline-block;
  width: 1.5em; /* Réduit la longueur de la ligne pour plus de flexibilité */
  height: 2px; /* Épaisseur de la ligne */
  background-color: #fff;
  margin: 0 0.3em; /* Réduit l'espacement pour éviter les débordements */
}

.text {
  margin: 0 0.3em; /* Réduit l'espacement pour plus de flexibilité */
}

/* Style pour l'élément principal */
main {
  padding: 0;
  color: #fff; /* Couleur du texte blanc */
}

#app {
  min-height: 100vh;
  background-color: #000 !important; /* Fond noir */
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Styliser le footer */
.app-footer {
  text-align: center;
  padding: 1em;
  background-color: #000;
  color: #fff;
  font-size: 0.9em;
  font-family: 'Bebas Neue', sans-serif; /* Appliquer la police Bebas Neue */
  text-transform: uppercase;
}

/* Responsive Style pour le header */
@media (max-width: 600px) {
  .app-header {
    padding-top: 2em;
    padding-bottom: 2em;
  }
  .logo-text {
    font-size: 1.5em; /* Réduire davantage la taille sur mobile */
  }
  .dot {
    margin: 0 0.2em; /* Réduire l'espacement des points */
  }
  .line {
    width: 1em; /* Réduire la longueur des lignes */
    margin: 0 0.1em; /* Réduire l'espacement autour des lignes */
  }
  .text {
    margin: 0 0.1em; /* Réduire l'espacement autour des mots */
  }
}

</style>
